<div>

    <!-- correct answers -->
    <div class="mb-8 ml-3">

      <app-view-quiz-object-tree [objectIds]="question.data.correctAnswer">
      </app-view-quiz-object-tree>

    </div>

    <!-- user answers -->
    <app-view-quiz-answer-option [correct]="isCorrect" #selectAnatomyAnswer>
      <div class="flex flex-column text-semibold">

        <div>
          {{ selectAnatomyAnswer.correct ? 'Correct' : 'Incorrect' }}! You selected:
        </div>

        <div class="mt-2 ml-2">
          <app-view-quiz-object-tree [objectIds]="answer">
          </app-view-quiz-object-tree>
        </div>

      </div>

    </app-view-quiz-answer-option>

    <div *ngIf="!summary && !isCorrect" class="mt-4">
    
      <button 
        class="w-100 mv-2"
        buttonType="outline"
        buttonTheme="light"
        app-button
        data-test="highlightUserAnswers"
        (click)="handleSelectedObjectsClick(answer)">Highlight My Answer</button>

      <button 
        class="w-100 mv-2"
        buttonType="outline"
        buttonTheme="light"
        app-button
        data-test="highlightCorrectAnswers"
        (click)="handleCorrectObjectsClick(question.data.correctAnswer)">Highlight Correct Answer</button>

    </div>

  </div>